module.exports = __webpack_public_path__ + "img/home-clothing7.f2681824.png";